import { useMutation } from 'react-query';

import {
  useRequest,
  MutationFunction,
  QuoteItemMatchesData,
} from '@frontend/api';

export type MoveQuoteFilesToLineItemsData = never;

export type MoveQuoteFilesToLineItemsRequestBody = {
  lineItemToQuoteFilesMap: QuoteItemMatchesData;
};

export type UseMoveQuoteFilesToLineItemsParams = {
  quoteId: number | string;
};

export const getUseMoveQuoteFilesToLineItemsKey = (
  params: UseMoveQuoteFilesToLineItemsParams,
) => ['moveQuoteFilesToLineItems', params.quoteId] as const;

export const useMoveQuoteFilesToLineItems: MutationFunction<
  MoveQuoteFilesToLineItemsData,
  MoveQuoteFilesToLineItemsRequestBody,
  [UseMoveQuoteFilesToLineItemsParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const mutationKey = getUseMoveQuoteFilesToLineItemsKey(params);
  const { quoteId } = params;
  const urlPath = `/quotes/${quoteId}/move_quote_files_to_line_items`;

  return useMutation(
    (body) => {
      return request(urlPath, {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey,
    },
  );
};
